import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  message: "",
  status: "success",
};

const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    showMessage(state, action) {
      const { message, status } = action.payload;
      state.show = true;
      state.message = message;
      state.status = status;
    },
    resetMessage(state) {
      state.show = false;
      state.message = "";
      state.status = "success";
    },
  },
});

export const pageActions = pageSlice.actions;
export default pageSlice.reducer;
